import React, {Component} from 'react';
import {intlShape} from 'react-intl';

import './SoftDeclineMessage.less';
import NotificationBanner, {BANNER_STYLE, NOTIFICATION_TYPE} from '../../../shared-components/NotificationBanner/NotificationBanner';

const LOCALE_PREFIX = 'DE/pages/RepaymentPage/RepaymentPage';

export class SoftDeclineMessage extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
    };

    render() {
        const { intl } = this.props;

        return (
            <NotificationBanner
                bannerStyle={BANNER_STYLE.LIGHT_BG}
                className="softDeclineMessage"
                condensed
                message={intl.formatMessage({ id: `${LOCALE_PREFIX}.softDeclineMessage`})}
                type={NOTIFICATION_TYPE.WARNING}
                useVX
            />
        );
    }
}


export default SoftDeclineMessage;
